import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import EventManagerDetailsLayer from "../components/EventManagerDetailsLayer";

const EventManagerDetailsPage = () => {
  return (
    <MasterLayout>
      <EventManagerDetailsLayer />
    </MasterLayout>
  );
};

export default EventManagerDetailsPage;
